"use strict";
const messages = {
'ALERT-MIC': 'Missing Microphone',
'ALERT-SPEAKER': 'Missing Speaker',
'AUDIOCONTROLS-INPUT-HEADING': 'Input',
'AUDIOCONTROLS-OUTPUT-HEADING': 'Output',
'AUDIOCONTROLS-CANCEL-BTN-LABEL': 'Cancel',
'AUDIOCONTROLS-SAVE-BTN-LABEL': 'Save',
'CALLCONTROLS-MUTE-BTN-LABEL' : 'Mute',
'CALLCONTROLS-HOLD-BTN-LABEL' : 'Hold',
'CALLCONTROLS-AUDIO-BTN-LABEL' : 'Audio',
'CALLCONTROLS-KEYPAD-BTN-LABEL' : 'Keypad',
'CALLCONTROLS-TRANSFER-BTN-LABEL' : 'Transfer',
'CALLCONTROLS-NEWCALL-BTN-LABEL' : 'New Call',
'CALLCONTROLS-HANGUP-BTN-LABEL' : 'Hang Up',
'CALLLIST-NOCALL' : 'No Active Call',
'CANCEL-BTN-LABEL' : 'Cancel',
'EMAIL-PLACEHOLDER' : 'Email address',
'BACK-BTN-LABEL': 'Back',
'INCOMINGCALL-HEADER' : 'Incoming Call',
'INCOMINGCALL-ACCEPT' : 'Accept',
'INCOMINGCALL-DECLINE' : 'Decline',
'INCOMINGCALL-VOICEMAIL' : 'Send to Voicemail',
'LOGIN-INPUT-EMAIL-PLACEHOLDER' :'Email address',
'LOGIN-INPUT-PASSWORD-PLACEHOLDER' : 'Password',
'LOGIN-CHECKBOX-LABEL' : 'Remember Me',
'LOGIN-FORGOTPASSWORD-LINK' : 'Forgot password?',
'LOGIN-SIGNIN-BTN-LABEL' : 'Sign In',
'LOGIN-FORGOTPW-INFO-TEXT' : 'Enter your email address to reset your password.',
'LOGIN-INPUT-PASSWORD-ERROR' : 'Please enter complete password',
'LOGIN-INPUT-EMAIL-ERROR' : 'Please enter valid email',
'LOGIN-RESETPW-INPUT-PASSWORD-ERROR': 'Passwords must match',
'LOGIN-FORGOTPW-RESETPASSWORD-BTN-LABEL' : 'Reset',
'LOGIN-RESETPW-INFO-TEXT' : ', please change your password. Passwords should contain at least one letter, no white space, 8 or more characters; and not start with @.',
'LOGIN-RESETPW-CHANGE-BTN-LABEL' : 'Change',
'LOGIN-RESETPW-NOTNOW-BTN-LABEL' : 'Cancel',
'LOGIN-TERMS' : 'Terms of Use',
'LOGIN-PRIVACY-POLICY' : 'Privacy Policy',
'LOGIN-COPYRIGHT' : '&copy; 2020 Star2Star Communications, LLC.  All rights reserved.',
'SETTINGS-VIEWALERT-BTN-LABEL' : 'View Alerts',
'SETTINGS-VERSION' : 'version ',
'SETTINGS-HELPDOC-BTN-LABEL' : 'Help Documentation',
'SETTINGS-CHECKBOX-LABEL' : 'Enable',
'SETTINGS-CHECKBOX-HEADER' : 'Always on Top?',
'SETTINGS-CLOSEALERTS-BTN-LABEL' : 'Close Alerts',
'SETTINGS-LOGOUT-BTN-LABEL' : 'Logout',
'SETTINGS-SELECT-EXTENSION-HEADER': 'Extension',
'SETTINGS-SELECT-RINGTONE-HEADER': 'Ringtone',
'SETTINGS-SELECT-INPUTDEVICE-HEADER': 'Input Device',
'SETTINGS-SELECT-OUTPUTDEVICE-HEADER': 'Output Device',
'SETTINGS-SELECT-INTERFACETHEME-HEADER': 'Interface Theme',
'SETTINGS-SELECT-INTERFACELANGUAGE-HEADER': 'Interface Language',
'CALLHISTORY-BACK-BTN-LABEL' : 'Back',
'CALLHISTORY-CLEAR-HISTORY-BTN-LABEL' : 'Clear',
'CALLHISTORY-HEADER' : 'History',
'CALLHISTORY-NO-HISTORY-MSG' : 'No Call History',
'ALERTLOG-SETTINGS-BTN-LABEL' : 'Settings',
'ALERTLOG-CLEAR-ALERT-BTN-LABEL' : 'Clear',
'ALERTLOG-HEADER' : 'Alerts',
'ALERTLOG-NO-ALERT-MSG' : 'No available alerts',
'UTILITIES-STATUS-ONHOLD' : 'On Hold',
'UTILITIES-STATUS-MUTED' : 'Muted',
'UTILITIES-STATUS-ACTIVE' : 'Active',
'UTILITIES-STATUS-DIALING' : 'Dialing',
'ALERTITEM-HEADING-LOGIN' : 'Login',
'ALERTITEM-BODY-INCORRECT-CREDENTIALS-MSG' : 'The username or password you entered is incorrect.',
'ALERTITEM-HEADING-LOST-NETWORK-CONNECTION' : 'Lost network connection. Check connection status.',
'DIALINPUT-PLACEHOLDER-TEXT' : 'Enter a number to call',
'CALLDETAILS-HOLD' : 'On Hold',
'CALLDETAILS-MUTED' : 'Muted',
'CALLLIST-STATUS-ACTIVE' : 'Active',
'CALLLIST-STATUS-DIALING' : 'Dialing',
'CALLHISTORY-STATUS-FAILED' : 'Failed',
'HEADING-STATUS-CONNECTED' : 'Connected',
'HEADING-STATUS-OFFLINE' : 'Offline',
'BLIND-BTN-LABEL': 'Blind',
'ATTENDED-BTN-LABEL': 'Attended',
'SOFTPHONE-DTMF-COMMANDS': "Enter Number",
'ARIA-LOGIN-SIGNIN-BTN': "Sign in button",
'ARIA-LOGIN-FORGOTPASSWORD-BTN': "Forgot password button",
'ARIA-CANCEL-BTN': "Cancel button",
'ARIA-LOGIN-FORGOTPW-RESETPASSWORD-BTN': "Reset password button",
'ARIA-LOGIN-RESETPW-NOTNOW-BTN-LABEL': "Not now button",
'ARIA-CALLHISTORY-BACK-BTN-LABEL': 'Back button',
'ARIA-CALLHISTORY-CLEAR-HISTORY-BTN-LABEL': 'Clear history button',
'ARIA-SETTINGS-LOGOUT-BTN': "Logout button",
'ARIA-SETTINGS-VIEWALERT-BTN': "View alerts button",
'ARIA-SETTINGS-HELPDOC-BTN': "Help documentation button",
'ARIA-RESETPW-CHANGE-BTN-LABEL': "Change password button",
'ARIA-BACKSPACE-BTN': 'Backspace button',
'ARIA-DIALING-INPUT-FIELD': 'Dialing input field',
'ARIA-HEADER': 'Header',
'ARIA-CLEAR-ALERTS-BUTTON': 'Clear alerts button',
'ARIA-ALERT-LIST': 'Alert list',
'ARIA-CHECKBOX': 'Checkbox',
'ARIA-SAVE-BTN': 'Save button',
'ARIA-INPUT-FIELD': 'Input field',
'ARIA-INPUT': 'Input',
'ARIA-KEYPAD': 'Keypad',
'ARIA-KEY': 'Key',
'ARIA-AUDIO-SLIDER': 'Audio slider',
'ARIA-AUDIO-SLIDER-CONTROL': 'Audio slider control',
'ARIA-MENU-ITEM': 'Menu item',
'ARIA-DROP-DOWN-MENU': 'Drop down menu',
'ARIA-BADGE-BUTTON': 'Badge button',
'ARIA-CALL-DETAIL': 'Call detail',
'ARIA-OPEN-SETTINGS-BUTTON': 'Open settings button',
'UPDATE-HEADER': 'Update Available',
'UPDATE-MSG': 'Would you like to restart the application now?',
'UPDATE-POSTPONE-BUTTON': 'Postpone (1 Min)',
'UPDATE-UPDATE-BUTTON': 'Update',
'ARIA-UPDATE-POSTPONE-BUTTON': 'Postpone Button',
'ARIA-UPDATE-UPDATE-BUTTON': 'Update Button',
'LOGIN-INPUT-SHOW': 'Show',
'LOGIN-INPUT-HIDE': 'Hide',
'ACTIVECALL-STATUS-RINGING': 'Ringing',
'ACTIVECALL-STATUS-ACTIVE': 'Active',
'ACTIVECALL-STATUS-DIALING': 'Dialing',
'ACTIVECALL-STATUS-FAILED': 'Failed',
'CALLHISTORY-TODAY': 'Today',
'CALLHISTORY-YESTERDAY': 'Yesterday',
'ALERT_FORGOT_PASSWORD': 'Forgot Password',
'ALERT_SETTINGS_WILL_APPLY': 'Active calls; settings will apply when idle.',
'ALERT_DIALING_OPTIONS': 'Dialing Options',
'ALERT_DIALING_OPTIONS_BODY': 'Missing dial plan options',
'ALERT_LOGIN': 'Login',
'ALERT_SOFTPHONE_EXTENSION': 'No softphone extension',
'ALERT_MORE_INFORMATION': 'For more information visit:',
'ALERT_LOST_CONNECTION': 'Lost network connection. Check connection status.',
'ARIA-PLAY-BTN': 'Play button',
'ARIA-STOP-BTN': 'Stop button',
'CONTACTS-STATUS-ONLINE': 'Online',
'CONTACTS-STATUS-OFFLINE': 'Offline',
'CONTACTS-STATUS-BUSY': 'Busy',
'CONTACTS-STATUS-UNKNOWN': 'Unknown',
'LABELLEDINPUT-LABEL-EMAIL': "Email address",
'LABELLEDINPUT-LABEL-PASSWORD': "Password",
'LABELLEDINPUT-LABEL-TEXT': "Text",
'LABELLEDINPUT-HINT-EMAIL': "Enter a valid email address below.",
'LABELLEDINPUT-HINT-PASSWORD': "Enter a valid password below.",
'LABELLEDINPUT-HINT-TEXT': "Enter text below.",
'ARIA-ICON-AREA': 'Icon Area',
'PARTICIPANT-LIST-ITEM-REMOVE-BUTTON': "Remove",
'PARTICIPANT-LIST-ITEM-ADD-BUTTON': "Add",
'SETTINGS-ADVANCED-LOGGING': "Advanced Logging",
'APPMENU-SETTINGS-BTN-LABEL': "Open Settings",
'APPMENU-HELP-BTN-LABEL': "Help documentation",
'APPMENU-LOGOUT-BTN-LABEL': "Logout",
'APPMENU-VERSION': "version ",
'HEADER-SETTINGS-TITLE': "Settings",
'SETTINGS-NOTIFICATIONS-BTN-LABEL': "Notifications",
'SETTINGS-APPEARANCE-BTN-LABEL': "Appearance",
'SETTINGS-CONTACTS-BTN-LABEL': "Contacts",
'SETTINGS-TROUBLESHOOTING-BTN-LABEL': "Troubleshooting",
'SETTINGS-NOTIFICATIONS-BTN-DESCRIPTION': "Adjust how you receive updates.",
'SETTINGS-APPEARANCE-BTN-DESCRIPTION': "Change the look and feel of the application.",
'SETTINGS-CONTACTS-BTN-DESCRIPTION': "Import your contacts.",
'SETTINGS-TROUBLESHOOTING-BTN-DESCRIPTION': "Tools to help you find out what's wrong",
'ARIA-BACK-BTN-LABEL': "Back",
'HEADER-BACK-ARIA-LABEL' : 'back',
'ENTITYLIST-SEARCH-FOUND': "found.",
'ENTITYLIST-SEARCH-ITEM-PLURAL': "items",
'ARIA-EVENT-LIST-ADD-NEW-GROUP': 'New Group',
'ENTITYLIST-NO-CONTACTS-FOUND': 'No contacts found',
'ENTITYLIST-TRY-IMPORTING': 'Try importing or adding a contact.',
'ZEROSTATE-IMPORT-BTN-LABEL': 'Import',
'ZEROSTATE-ADD-CONTACT-BTN-LABEL': 'Add Contact',
'ENTITYLIST-NO-CONTACTS-DESCRIPTION': 'Enter the number to send or import your contact list in settings.',
'ENTITYLIST-SEARCHBAR-SEARCH-CONTACTS': "Search contacts",
'CONTACT-DETAILS-CARD-ZERO-STATE-BUTTON-LABEL' : 'Add a number',
'CONTACT-DETAILS-CARD-ZERO-STATE-TITLE': 'No Contact Information',
'CONTACT-DETAILS-CARD-ZERO-STATE-DESCRIPTION': 'Add a number to get started',
'ARIA-CARD-DETAILS-EDIT': 'Edit',
'ARIA-CARD-DETAILS-DELETE': 'Delete',
'SETTINGS-DEVICES-BTN-LABEL': "Devices",
'SETTINGS-DEVICES-BTN-DESCRIPTION': "Change how your devices are configured.",
'HEADER-CONTACTS-ARIA-LABEL' : "contacts",
"SETTINGS-CATEGORY-HEADER-TROUBLESHOOTING": "Troubleshooting",
"SETTINGS-TROUBLESHOOTING-CHECKBOX-LABEL": "Enable advanced logging",
"SETTINGS-TROUBLESHOOTING-DESCRIPTION" : "When enabled the application will create advanced logs to help with diagnosing application errors.",
"SETTINGS-ADVANCED-LOGGING-TITLE" : 'Advanced Logging',
'SETTINGS-CATEGORY-HEADER-ALERTS': "Alerts",
"SETTINGS-VIEW-ALERTS-TITLE" : "View Alerts",
"SETTINGS-VIEW-ALERTS-DESCRIPTION": "Access a record of alerts and logs.",
"SETTINGS-NOTIFICATIONS-TITLE": "Ring tone",
"SETTINGS-NOTIFICATIONS-DESCRIPTION": "Change the ring tone used for incoming voice calls.",
"APPMENU-DEFAULT-THEME-BTN-LABEL": "Default",
"APPMENU-LIGHT-THEME-BTN-LABEL": "Light",
"APPMENU-DARK-THEME-BTN-LABEL": "Dark",
"SETTINGS-APPEARANCE-TITLE-ALWAYS-ON-TOP": "Always on top",
"SETTINGS-ALWAYS-ON-TOP-DESCRIPTION": "When enabled the application will always display above your other applications.",
'SETTINGS-APPEARANCE-CHECKBOX-LABEL': "Always on top?",
'SETTINGS-APPEARANCE-TITLE-THEME': "Theme",
'SETTINGS-THEMES-DESCRIPTION': "Themes change the overall appearance of the application.",
'SETTINGS-APPEARANCE-TITLE-LANGUAGE': "Language",
'SETTINGS-LANGUAGE-DESCRIPTION': "Changing the language changes it throughout the application.",
'SETTINGS-CATEGORY-HEADER-DEVICE': "Device",
'SETTINGS-CATEGORY-HEADER-CONTACTS': "Contacts",
'SETTINGS-CATEGORY-HEADER-APPEARANCE': "Appearance",
'SETTINGS-CATEGORY-HEADER-NOTIFICATIONS': "Notifications",
'SETTINGS-INPUT-DEVICE-TITLE': "Input Device",
'SETTINGS-INPUT-DEVICE-DESCRIPTION': "Set the audio device you want to use for input.",
'SETTINGS-OUTPUT-DEVICE-TITLE': "Output Device",
'SETTINGS-OUTPUT-DEVICE-DESCRIPTION': "Set the audio device you want to use for output.",
'SETTINGS-CONTACTS-IMPORT-YOUR-CONTACTS': "Import Your Contacts",
'SETTINGS-CONTACTS-IMPORT-CONTACTS-DESCRIPTION': "Select your option below to import contacts.",
'SETTINGS-CONTACTS-SAMPLE-CSV': "Sample CSV",
'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-DESCRIPTION': "Pressing the button below will download a sample CSV file.",
'SETTINGS-CONTACTS-BACKUP': 'Backup',
'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-DESCRIPTION': "Pressing the button below will download a CSV backup of your contacts. This is recommended before imports.",
'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-BUTTON': 'Download Sample',
'SETTINGS-IMPORT-LAST-SYNC-LABEL': "Imported",
'SETTINGS-IMPORT-CONTACTS-SOURCES-BUTTON': "Import",
'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-BUTTON': 'Download Backup',
'CONTACT-DETAILS-CARD-MODAL-CANCEL-BUTTON': "Cancel",
'CONTACT-DETAILS-CARD-MODAL-DELETE-BUTTON': "Delete",
'CONTACT-DETAILS-CARD-MODAL-HEADER-DELETE-CONTACT' : "Are you sure you want to delete this contact?",
'CONTACT-DETAILS-CARD-MODAL-DESCRIPTION-DELETE-CONTACT': "Completing this action will permanently remove the current contact’s information. ",
'CONTACT-DETAILS-FORM-ERROR': 'A field in the form below has an error.',
'CONTACT-DETAILS-FORM-PERSONAL-INFO-HEADER': 'Personal Information',
'CONTACT-DETAILS-FORM-FIRST-NAME-HEADER': 'First Name',
'CONTACT-DETAILS-FORM-FIRST-NAME-PLACEHOLDER': 'Enter First Name',
'CONTACT-DETAILS-FORM-LAST-NAME-HEADER': 'Last Name',
'CONTACT-DETAILS-FORM-LAST-NAME-PLACEHOLDER': 'Enter Last Name',
'CONTACT-DETAILS-FORM-COMPANY-NAME-HEADER': 'Company',
'CONTACT-DETAILS-FORM-COMPANY-NAME-PLACEHOLDER': 'Enter Company Name',
'CONTACT-DETAILS-FORM-PHONE-NUMBERS-HEADER': 'Phone Numbers',
'CONTACT-DETAILS-FORM-PHONE-BTN-LABEL': 'Add Phone',
'CONTACT-DETAILS-FORM-CANCEL-BTN-LABEL': 'Cancel',
'CONTACT-DETAILS-FORM-SAVE-BTN-LABEL': 'Save',
'CONTACT-DETAILS-FORM-NEW-CONTACT-HEADER': 'New Contact',
'CONTACT-DETAILS-FORM-EDIT-CONTACT-HEADER': 'Edit Contact',
'CONTACT-DETAILS-FORM-INPUT-ERROR': 'This field cannot be left blank.',
'CONTACT-DETAILS-FORM-NUMBER-HEADER':'Number',
'CONTACT-DETAILS-FORM-NUMBER-ERROR':'Please enter a valid 10 digit number',
'CONTACT-DETAILS-FORM-NUMBER-PLACEHOLDER':'Enter Number...',
'CONTACT-DETAILS-FORM-PREFERRED-LABEL':'Preferred?',
'CONTACT-DETAILS-FORM-SELECT-HOME': 'Home',
'CONTACT-DETAILS-FORM-SELECT-BUSINESS': 'Business',
'CONTACT-DETAILS-FORM-SELECT-MOBILE': 'Mobile',
'CONTACT-DETAILS-FORM-SELECT-OTHER': 'Other',
'CONTACT-DETAILS-FORM-SELECT-LABEL': 'Label',
'NUMBER-SELECTION-MODAL-SELECT-NUMBER-TO-CALL': 'Select the number to call',
'NUMBER-SELECTION-MODAL-PREFERRED': 'Preferred',
'CONTACT-DETAILS-FORM-NUMBER-ERROR-PROP' : 'Please enter a valid number'
};

module.exports = messages;



// WEBPACK FOOTER //
// ./src/locales/locale-en.js